export const BUTTON_VARIANTS = {
    NAVLINK: 'NAVLINK',
    LINK: 'LINK',
    ANCHOR: 'ANCHOR'
} as const;
